// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13272(93fc2a06a8)-C13/10/2026-10:20:30-B13/10/2026-10:28:52' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13272(93fc2a06a8)-C13/10/2026-10:20:30-B13/10/2026-10:28:52",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13272",
  shortHash: "93fc2a06a8",
  longHash: "93fc2a06a8e84807f20b00efed4cb63a881abb2f",
  dateCommit: "13/10/2026-10:20:30",
  dateBuild: "13/10/2026-10:28:52",
  buildType: "Ansible",
  } ;
